export default __webpack_public_path__ + "static/media/news21.6d5ebe63.jpg";